import * as yup from 'yup';

export interface ZipCodeFormValues {
  zipCode: string;
}

export const validationMessages = {
  required: 'Required field',
  length: 'Enter a valid 5-digit zip code',
};

export const zipCodeValidationSchema = yup.object({
  zipCode: yup
    .string()
    .required(validationMessages.required)
    .test('length', validationMessages.length, (val) =>
      val ? val.toString().length === 5 : false
    ),
});
